import { createRoute } from "@tanstack/react-router";

import { Quote360View } from "../components/Quote360View";
import { rootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/quotes/$quoteId",
  component: QuoteDetailScreen,
});

function QuoteDetailScreen() {
  const { quoteId } = Route.useParams();
  return <Quote360View quoteId={quoteId} />;
}
